// Feature: M004-F0718. Tests: T-M004-0219, T-M004-0220.
//
// WAI-ARIA tabs for the booking drawer (design 16.3): role tablist / tab / tabpanel, aria-selected, aria-controls,
// roving tabindex (only the selected tab is in the tab order). Left/Right move AND select (wrapping), Home/End jump to
// the first/last, Enter or Space activates. Tab from the tablist enters the panel (the panel is focusable).
import React, { useRef } from 'react';
import { BOOKING_DRAWER_TABS } from './bookingDrawerTabState';

export const TAB_ID_PREFIX = 'bkh-drawer-tab-';
export const PANEL_ID_PREFIX = 'bkh-drawer-panel-';

export default function BookingDrawerTabs({ selected, onSelect, tabs = BOOKING_DRAWER_TABS, panels }) {
  const refs = useRef({});
  const move = (index) => {
    const next = tabs[(index + tabs.length) % tabs.length];
    onSelect(next.key);
    const node = refs.current[next.key];
    if (node) node.focus();
  };
  const onKeyDown = (event, index) => {
    switch (event.key) {
      case 'ArrowRight': event.preventDefault(); move(index + 1); break;
      case 'ArrowLeft': event.preventDefault(); move(index - 1); break;
      case 'Home': event.preventDefault(); move(0); break;
      case 'End': event.preventDefault(); move(tabs.length - 1); break;
      case 'Enter':
      case ' ': event.preventDefault(); onSelect(tabs[index].key); break;
      default: break;
    }
  };
  return (
    <>
      <div className="bkh-drawer-tabs" role="tablist" aria-label="Booking sections" data-testid="bkh-drawer-tabs">
        {tabs.map((tab, index) => (
          <button
            key={tab.key}
            ref={(node) => { refs.current[tab.key] = node; }}
            type="button"
            role="tab"
            id={`${TAB_ID_PREFIX}${tab.key}`}
            aria-selected={selected === tab.key}
            aria-controls={`${PANEL_ID_PREFIX}${tab.key}`}
            tabIndex={selected === tab.key ? 0 : -1}
            className={`bkh-drawer-tab${selected === tab.key ? ' active' : ''}`}
            data-testid={`bkh-drawer-tab-${tab.key}`}
            onClick={() => onSelect(tab.key)}
            onKeyDown={(event) => onKeyDown(event, index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          role="tabpanel"
          id={`${PANEL_ID_PREFIX}${tab.key}`}
          aria-labelledby={`${TAB_ID_PREFIX}${tab.key}`}
          tabIndex={0}
          hidden={selected !== tab.key}
          className="bkh-drawer-tabpanel"
          data-testid={`bkh-drawer-tabpanel-${tab.key}`}
        >
          {selected === tab.key ? panels[tab.key] : null}
        </div>
      ))}
    </>
  );
}
